import optimizelySDK, { createInstance } from '@optimizely/optimizely-sdk';
import getOptimizelyConfig from './getOptimizelyConfig.js';
const twoSecondsMS = 2000;
let serverOptimizelyClientInstance;
let browserOptimizelyClientInstance;
let dataFileCache;
export const updateOptimizelyDataFile = dataFile => {
  const optimizelyConfig = getOptimizelyConfig();
  if (!serverOptimizelyClientInstance) {
    const instance = browserOptimizelyClientInstance;
    const currentDataFileRevision = instance && instance.getOptimizelyConfig().revision;
    if (dataFile.revision !== currentDataFileRevision) {
      if (instance) {
        instance.close();
      }
      optimizelySDK.setLogger(optimizelySDK.logging.createLogger());
      optimizelySDK.setLogLevel(optimizelyConfig.logLevel);
      browserOptimizelyClientInstance = createInstance({
        datafile: dataFile,
        eventBatchSize: optimizelyConfig.eventBatchSize,
        eventFlushInterval: optimizelyConfig.eventFlushInterval
      });
    }
  }
};
const updateDataFileCache = async () => {
  const optimizelyConfig = getOptimizelyConfig();
  const newDataFile = serverOptimizelyClientInstance.projectConfigManager.datafileManager.get();
  optimizelySDK.setLogger(optimizelySDK.logging.createLogger());
  optimizelySDK.setLogLevel(optimizelyConfig.logLevel);
  const fakeInstance = createInstance({
    datafile: newDataFile,
    eventBatchSize: optimizelyConfig.eventBatchSize,
    eventFlushInterval: optimizelyConfig.eventFlushInterval
  });
  const {
    success
  } = await fakeInstance.onReady({
    timeout: twoSecondsMS
  });
  if (success) {
    fakeInstance.close();
    dataFileCache = newDataFile;
  } else {
    // eslint-disable-next-line no-console
    console.log('Optimizely datafile could not be validated.');
  }
};
export const createOptimizelyInstance = async () => {
  const optimizelyConfig = getOptimizelyConfig();
  // Logging options are 'notset', 'debug', 'info', 'warn' (='warning'), 'warning', and 'error'.
  // Default log level is 'error'.
  // https://docs.developers.optimizely.com/full-stack/docs/customize-logger-javascript-node
  optimizelySDK.setLogger(optimizelySDK.logging.createLogger());
  optimizelySDK.setLogLevel(optimizelyConfig.logLevel);
  if (!serverOptimizelyClientInstance) {
    const potentialInstance = createInstance({
      // sdkKey is required because the Optimizely instance will ignore autoUpdate if sdkKey is missing
      // (it thinks it needs it because the urlTemplate is allowed to contain a token that gets replaced by the
      // sdkKey)
      sdkKey: optimizelyConfig.sdkKey,
      datafileOptions: {
        autoUpdate: true,
        updateInterval: optimizelyConfig.instanceRefreshInterval,
        urlTemplate: optimizelyConfig.dataFilePath
      },
      eventBatchSize: optimizelyConfig.eventBatchSize,
      eventFlushInterval: optimizelyConfig.eventFlushInterval
    });
    const {
      success,
      reason
    } = await potentialInstance.onReady({
      timeout: twoSecondsMS
    });
    if (success) {
      serverOptimizelyClientInstance = potentialInstance;

      // These next two lines keep `dataFileCache` up-to-date.
      serverOptimizelyClientInstance.projectConfigManager.onUpdate(updateDataFileCache);
      await updateDataFileCache();
    } else {
      // eslint-disable-next-line no-console
      console.error('Error initializing Optimizely:', reason);
      return undefined;
    }
  }
  return serverOptimizelyClientInstance;
};

// TODO: remove this line once a datafile accessor is provided by the SDK. Also remove uses of dataFileCache above.
export const getOptimizelyDataFile = () => typeof dataFileCache === 'string' ? JSON.parse(dataFileCache) : dataFileCache;
const getOptimizelyInstance = () => serverOptimizelyClientInstance || browserOptimizelyClientInstance;
export default getOptimizelyInstance;